<template>
  <div class="roomie-range">
    <label
      v-if="label"
      :for="id"
      class="roomie-range__label">
      {{ label }}
    </label>

    <div
      class="roomie-range__input"
      :class="`roomie-range__input--${size} roomie-range__input--${variant} roomie-range__input--width-${width}`">
      <input
        :id="id"
        :value="currentValue"
        :step="step"
        :min="min"
        :aria-label="ariaLabel"
        :max="max"
        type="range"
        :data-lh-id="trackingLhId"
        :style="{
          '--track-width': progress
        }"
        @input="handleInput">
    </div>
  </div>
</template>

<script>

export { VARIANT } from './utils'

export default {
  name: 'RoomieRange',
  props: {
    ariaLabel: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: null
    },
    modelValue: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: 100
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg'].includes(value)
    },
    width: {
      type: String,
      default: 'md',
      validator: value => ['md', 'lg'].includes(value)
    },
    variant: {
      type: String,
      default: 'accent',
      required: false,
      validator: (value) => ['accent', 'brand'].includes(value)
    },
    trackingLhId: {
      type: String,
      default: ''
    },
  },
  emits: ['input', 'update:modelValue'],
  computed: {
    currentValue () {
      return this.value ?? this.modelValue ?? 0
    },
    progress () {
      const width = (this.currentValue - this.min) / (this.max - this.min) * 100
      return `${width}%`
    }
  },
  methods: {
    handleInput (event) {
      const value = parseInt(event.target.value)
      this.$emit('input', value)
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
